// Recently Viewed Products Tracker
class RecentlyViewedTracker {
  constructor() {
    this.storageKey = 'recentlyViewed';
    this.maxProducts = 12; // Store up to 12 products
    this.currentProductId = null;
  }

  init() {
    // Get current product ID from page
    this.currentProductId = this.getCurrentProductId();
    
    if (this.currentProductId) {
      this.addProduct(this.currentProductId);
    }
  }

  getCurrentProductId() {
    // Try multiple ways to get product ID
    const metaTag = document.querySelector('meta[property="product:retailer_item_id"]');
    if (metaTag) return metaTag.content;

    // Check for product form
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (productForm) {
      const idInput = productForm.querySelector('input[name="id"]');
      if (idInput) return idInput.value;
    }

    // Check for data attributes
    const productElement = document.querySelector('[data-product-id]');
    if (productElement) return productElement.dataset.productId;

    // Fallback: extract from URL or global variables
    if (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product) {
      return window.ShopifyAnalytics.meta.product.id.toString();
    }

    return null;
  }

  addProduct(productId) {
    let recentlyViewed = this.getRecentlyViewed();
    
    // Remove if already exists (to move to front)
    recentlyViewed = recentlyViewed.filter(id => id !== productId);
    
    // Add to front
    recentlyViewed.unshift(productId);
    
    // Limit to max products
    if (recentlyViewed.length > this.maxProducts) {
      recentlyViewed = recentlyViewed.slice(0, this.maxProducts);
    }
    
    // Save to localStorage
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(recentlyViewed));
    } catch (e) {
      console.warn('Could not save recently viewed products:', e);
    }
  }

  getRecentlyViewed() {
    try {
      const stored = localStorage.getItem(this.storageKey);
      return stored ? JSON.parse(stored) : [];
    } catch (e) {
      console.warn('Could not load recently viewed products:', e);
      return [];
    }
  }

  getRecentlyViewedForDisplay(limit = 8) {
    const recentlyViewed = this.getRecentlyViewed();
    
    // Exclude current product
    const filtered = recentlyViewed.filter(id => id !== this.currentProductId);
    
    return filtered.slice(0, limit);
  }
}

// Initialize tracker
const recentlyViewedTracker = new RecentlyViewedTracker();

// Wait for DOM and initialize
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => recentlyViewedTracker.init());
} else {
  recentlyViewedTracker.init();
}

// Make available globally for the liquid template
window.recentlyViewedTracker = recentlyViewedTracker;